import React from 'react';
import { jsPDF } from 'jspdf';

const DownloadPDF = ({ text }) => {
  const generatePDF = () => {
    const doc = new jsPDF();
    doc.setFont('Times New Roman');
    doc.setFontSize(12);

    // Convert HTML Line Breaks to normal Line Breaks
    const sanitizedText = text.replace(/<br\s*\/?>/gi, '\n').replace(/<div\s*\/?>/gi, '\n').replace(/<\/div\s*\/?>/gi, '\n').replace(/&nbsp;/g, ' ');
    
    const maxWidth = 180;
    const pageHeight = 280;  // height of the page, you may adjust it based on your needs
    let yPosition = 20;
    let xPosition = 10;

    const lines = sanitizedText.split('\n');
    for (const line of lines) {
      const words = line.split(' ');

      let lineBuffer = words[0];
      for (let i = 1; i < words.length; i++) {
        const testLine = lineBuffer + ' ' + words[i];
        const width = doc.getTextWidth(testLine);

        if (width > maxWidth) {
          doc.text(lineBuffer, xPosition, yPosition);
          lineBuffer = words[i];
          yPosition += 10;

          if (yPosition > pageHeight) {
            doc.addPage();
            yPosition = 20; // reset yPosition for the new page
          }
        } else {
          lineBuffer = testLine;
        }
      }

      doc.text(lineBuffer, xPosition, yPosition);
      yPosition += 10; 
      
      // check if the next line would be out of the page after adding current line.
      if (yPosition > pageHeight) {
        doc.addPage();
        yPosition = 20; // reset yPosition for the new page
      }
    }

    doc.save('document.pdf');
};

  
  return <button className='content-button status-button open' onClick={generatePDF}>Download as PDF</button>;
};

export default DownloadPDF;
